import { useContext } from 'react';
import { YearContext } from './yearContextDef';

export function useYear() {
  return useContext(YearContext);
}
